<span (click)="copyToClipBoard()" [title]="tooltip" role="button">
  @if (displayContent) {
    {{ content }}
  }
  <ng-content></ng-content>
</span>
